import React, {Component} from 'react';
import {BounceLoader} from 'react-spinners';
import {Link, browserHistory} from 'react-router';
import Moment from 'moment';
import Member from './OpportunityMembersComponent';
import PostCardComponent from 'components/PostCardComponent'
import OpportunityActions from 'actions/OpportunityActions';
import OpportunityStore from 'stores/OpportunityStore';
import API from 'sources/API';

require('styles/OpportunityDetail.scss');
require('styles/SweetLoading.scss');
require('styles/Referral.scss');

class OpportunityDetailComponent extends Component{
  constructor(props) {
    super(props);
    let opportunityStore = OpportunityStore.getState();
    let opportunity_id = this.props.params.id;
    this.state = {
      id: opportunity_id,
      opportunity:opportunityStore.opportunity,
      currentTab: 'register',
      status: opportunityStore.opportunity.hasConfirmed,
      isSignUp:opportunityStore.opportunity.isSignUp,
      phone: '',
      wechat: '',
      message: '',
      referral: {},
      addition: null, 
      is_referral: false,
      alertRevealShow: false,
      userRevealShow: false,
      messageRevealShow: false,
      postRevealShow: false,
      referralRevealShow: false,
      loading: true
    };
    this.onOpportunityChange = this.onOpportunityChange.bind(this);
    this.onTabChange = this.onTabChange.bind(this);
    this.opportunityPay = this.opportunityPay.bind(this);
    this.handleTextChange = this.handleTextChange.bind(this)
    this.toggleReveal = this.toggleReveal.bind(this);
    this.validateUserInfo = this.validateUserInfo.bind(this)
    this.getReferral = this.getReferral.bind(this)
    this.handleReferral = this.handleReferral.bind(this)
  }
  handleTextChange(event) {
    let state = {};
    state[event.target.name] = event.target.value;
    this.setState(state);
  }
  componentDidMount(){
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }
    window.scrollTo(0,0);
    OpportunityStore.listen(this.onOpportunityChange);
    OpportunityActions.fetchOpportunity(this.state.id);
    this.getReferral()
    
    window._hmt.push(['_trackPageview', this.props.location.pathname]);
  }
  componentWillUnmount(){
    OpportunityActions.clearOpportunity();
    OpportunityStore.unlisten(this.onOpportunityChange);
  }
  onOpportunityChange(store){
    this.setState({
      opportunity: store.opportunity,
      status:store.opportunity.hasConfirmed,
      isSignUp:store.opportunity.isSignUp,
      loading: (store.opportunity._id&&store.opportunity._id===this.props.params.id)?false:true
    });

    let opportunity = store.opportunity;    
    if(opportunity && opportunity.title){
      let title = opportunity.title;
      let img = opportunity.imageUrl;
      window.wx.onMenuShareTimeline({
        title: `${title}-小地球旅行`,
        link:  location.href.split('?')[0],
        imgUrl: encodeURI(img.replace('list','li150'))
      });
      window.wx.onMenuShareAppMessage({
        title: `${title}-小地球旅行`,
        desc: `${title}。加入小地球旅行，发现有趣的地方`,
        link: location.href.split('?')[0],
        imgUrl: encodeURI(img.replace('list','li150')),
        type: 'link'
      });
      window.changeMetaForSEO(opportunity.title);
    }
  }
  onTabChange(tab) {
    this.setState({currentTab: tab});
  }
  opportunityPay(){
    let check = API.checkToken;
    let { id, phone, wechat, message }  = this.state;
    if(!phone||!wechat) return
    if(this.state.loading) return
    if(check) {
      if(!API.isWechat) {
        this.toggleReveal('alert');
        return;
      }
      this.setState({loading: true})
      let params = {
        method: 'POST',
        headers: API.jsonHeader,
        body: JSON.stringify({
          accessToken: API.accessToken,
          opportunity_id: id,
          phone,
          wechat,
          message
        })
      };
      let self = this
      fetch(API.postOpportunityPay, params)
        .then(res=>res.json())
        .then(json=>{
          self.setState({loading: false})
          function onBridgeReady(){
            window.WeixinJSBridge.invoke('getBrandWCPayRequest', json.options, function(res){
              OpportunityActions.fetchOpportunity(id);
              OpportunityActions.fetchOpportunityRegister(id);
              if(res.err_msg === "get_brand_wcpay_request：ok" || res.err_msg.indexOf("ok") !== -1 ) {
                browserHistory.push('/result/pay');
              }
            });
          }
          if (typeof WeixinJSBridge === "undefined"){
            if( document.addEventListener ){
              document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
            } else if (document.attachEvent){
              document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
              document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
            }
          } else {
            onBridgeReady();
          }
        });
    }
  }
  toggleReveal(type) {
    let key = `${type}RevealShow`;
    let newState = {};
    if(this.state[key]) {
      newState[key] = false;
    } else {
      newState[key] = true;
    }
    this.setState(newState);
  }
  validateUserInfo(){
    let {phone,wechat} = this.state
    if(!phone || !wechat){
      alert('请填写手机号和微信ID')
      return
    }
    this.setState({
      userRevealShow: false,
      messageRevealShow: true
    })
  }
  getReferral() {
    let user_id = this.props.location.query.uid
    const sendData = {
      first: 0,
      maxCount: 1,
      user_id: user_id 
    };
    let searchParams = new URLSearchParams();
    for(let k in sendData) {
      if(sendData[k] === 0 || sendData[k]) {
        searchParams.append(k, sendData[k]);
      }
    }
    const opp_id = this.props.params.id
    fetch(`${API.getOpportunityReferral.replace(':id',opp_id)}&${searchParams}`)
    .then(res=>res.json())
    .then(json=>{
      const { user,addition,is_referral } = json.result
      this.setState({
        referral: user,
        addition: addition,
        is_referral: is_referral,
      })
    });
  }
  handleReferral() {
    if (this.state.status) {
      alert('活动已截止')
      return
    }
    let check = API.checkToken;
    if(check){
      if(!this.state.loading) {
        this.setState({loading: true})
        let user_id = this.props.location.query.uid
        if(this.state.isSignUp&&this.state.isSignUp.status) {
          user_id = this.state.isSignUp.id 
        }
        console.log('user_id',user_id)
        let param = {
          method: 'POST',
          body: JSON.stringify({
            user_id: user_id
          }),
          headers: API.jsonHeader
        };
        const opp_id = this.props.params.id
        fetch(API.postOpportunityReferral.replace(':id',opp_id), param)
        .then(res=>res.json()
        .then(json=>{
          if(json.status == 0){
            this.setState({loading: false})
            this.getReferral()
          }
        }))
      }
    }
  }
  render(){
    let tab,content,alertReveal,userInfo,messageInfo,actions;
    switch(this.state.currentTab) {
      case 'register':
        tab = <Member id={this.props.params.id}
                tab={this.state.currentTab}
                selectSelecter={this.onTabChange.bind(this, 'selecter')}
                active={this.state.currentTab==='register'?true:false}
              />
        break;
      case 'selecter':
        tab = <Member id={this.props.params.id}
                tab={this.state.currentTab}
                selectSelecter={this.onTabChange.bind(this, 'selecter')}
                active={this.state.currentTab==='selecter'?true:false}
              />
        break;
    }

    if(this.state.status){
      content = (
        <div className="action order columns small-5 negative">已截止</div>
      );
    }else{
      if(this.state.isSignUp&&this.state.isSignUp.status){
        content = (
          <div className="action order columns small-5" onClick={this.toggleReveal.bind(this ,'referral')}>邀请助力</div>
        );
      }else{
        content = (
          <div className="action order columns small-5" onClick={this.toggleReveal.bind(this ,'user')}>报名 ¥{this.state.opportunity.price}</div>
        );
      }
    }
    let createMarkup = () =>  {
      return {__html: this.state.opportunity.format_content};
    }
    if(this.state.alertRevealShow) {
      alertReveal = (
        <div className="reveal-overlay">
          <div className="reveal">
            <button className="close-button" aria-label="Close modal" type="button" onClick={this.toggleReveal.bind(this ,'alert')}>
              <span aria-hidden="true">&times;</span>
            </button>
            <p className="mt-30 text-center">请在微信内完成支付。</p>
          </div>
        </div>
      );
    }
    if(this.state.userRevealShow){
      userInfo = (
        <div className="user-info">
          <div>
            <input type="text" name="phone" value={this.state.phone} onChange={this.handleTextChange} placeholder="必填：手机号" />
          </div>
          <div>
            <input type="text" name="wechat" value={this.state.wechat} onChange={this.handleTextChange} placeholder="必填：微信ID" />
          </div>
          <div>
            <button className="expanded button confirm" onClick={this.validateUserInfo}>确认</button>
          </div>
          <div>
            <button className="expanded button cancel" onClick={this.toggleReveal.bind(this ,'user')}>取消</button>
          </div>
        </div>
      )
    }else if(this.state.messageRevealShow){
      messageInfo = (
        <div className="message-info">
           <div>
            <textarea rows="5" type="text" name="message" value={this.state.message} onChange={this.handleTextChange} placeholder="个性留言~" />
          </div>
          <div>
            <button className="expanded button confirm" onClick={this.opportunityPay.bind(this)}>确认</button>
          </div>
          <div>
            <button className="expanded button cancel" onClick={this.toggleReveal.bind(this ,'message')}>取消</button>
          </div> 
        </div>
      )
    }else{
      actions = (
        <div className="actions">
          <div className="action collect columns small-7" onClick={this.toggleReveal.bind(this,'post')}>
            <i className="fa fa-share" aria-hidden="true"></i>&nbsp;活动海报
          </div>
          {content}
        </div>
      )
    }

    let postCardReveal;
    if(this.state.postRevealShow && this.state.opportunity._id){
      let url = location.href.split('?')[0] 
      postCardReveal = <PostCardComponent
                        title = {this.state.opportunity.title}
                        cover = {`${this.state.opportunity.imageUrl}!list`}
                        togglePostCard = {this.toggleReveal.bind(this,'post')}
                        url = {url}
                        />
    }

    let referralCardRevel;
    if(this.state.referralRevealShow && this.state.addition) {
      let url = `${location.href.split('?')[0]}?uid=${this.state.referral._id}`
      referralCardRevel = <PostCardComponent
                          title = {'活动助力：' + this.state.opportunity.title}
                          cover = {`${this.state.opportunity.imageUrl}!list`}
                          url = {url}
                          togglePostCard = {this.toggleReveal.bind(this,'referral')}
                          userInfo = {this.state.referral}
                          /> 
    }

    let {tel,wechat_name} = this.state.referral
    if(tel){
      tel = tel.replace(tel.substring(3,tel.length - 4),'****')
    }
    if(wechat_name){
      wechat_name = wechat_name.replace(wechat_name.substring(2,wechat_name.length),'**')
    }
    const styles = {
      border: '1px solid #e6e6e6',
      margin: '0 20px 15px',
      padding: '15px'
    }
    return (
      <div className='opportunityDetail-component'>
        <div className='sweet-loading'>
          <BounceLoader
            sizeUnit={"px"}
            size={50}
            color={'#333'}
            loading={this.state.loading}
          />
        </div>
        {alertReveal}
        <div className='cover-wrap'>
          <img className="cover" src={this.state.opportunity.imageUrl?`${this.state.opportunity.imageUrl}!list`:''} />
          <div className="title">{this.state.opportunity.title}</div>
        </div>
        <div className='content-component'>
          <div className="content">
            <pre className="content-intro" dangerouslySetInnerHTML={createMarkup()} />
          </div>
          <div className='timestamp'>发布时间：{this.state.opportunity?Moment(this.state.opportunity.create_date).format('YYYY-MM-DD HH:MM'):''}</div>
        </div>
        {this.state.addition?(
          <div className="referal-user-card" style={styles}>
            <div className="img-wrap">
              <img src={this.state.referral.avatar} />
            </div>
            <div className="nickname">{this.state.referral.name}</div>
            <div className="contacts">
              <div className="email">wechat: {wechat_name || '***'}</div>
              <div className="phone">tel: {tel || '***'}</div>
            </div>
            <div className="message mb-10">{this.state.addition.relation_info.msg}</div>
            {this.state.is_referral?<div className="referral-action completed">已助力</div>
          :<div className="referral-action" onClick={this.handleReferral}>为他助力</div>}
          </div>
        ):null}
        <div className='tip'>
          <div className='delegate'>注意事项：本活动需要用户报名时认真完善自己的个人信息，包括个性留言，以便我们了解大家和安排退款事项。关注”小地球旅行攻略“微信公众号可具体咨询您的专属微信客服，并获得活动结果推送.</div>
        </div>
        <div className="tab-nav row expanded text-center">
          <div className="small-6 columns">
            <a href="javascript:void(0);"
              onClick={this.onTabChange.bind(this, 'register')}
              className={this.state.currentTab==='register'?'active':''}
            >
              已报名
            </a>
          </div>
          <div className="small-6 columns">
            <a href="javascript:void(0);"
              onClick={this.onTabChange.bind(this, 'selecter')}
              className={this.state.currentTab==='selecter'?'active':''}
            >
              已获选
            </a>
          </div>
        </div>
        {tab}
        {actions}
        {userInfo}
        {messageInfo}
        {postCardReveal}
        {referralCardRevel}
      </div>
    );
  }
}

export default OpportunityDetailComponent;



// WEBPACK FOOTER //
// ./src/components/OpportunityDetailComponent.js